export default "__VITE_ASSET__SJgHtv4V__"